/**
 * @generated SignedSource<<1c9c243a57293b8445d24928c3b2eb3b>>
 * @relayHash 9713a87882c5e6383e438ee687952963
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 24fcf7d9198609064e8a85eb41bcf50e2a570e7e7bb679c9d58b3ffec028c495

import type { ConcreteRequest } from 'relay-runtime';
export type SpaceStarUnfavoriteSpaceMutation$variables = {
  spaceKey: string;
};
export type SpaceStarUnfavoriteSpaceMutation$data = {
  readonly unfavouriteSpace: {
    readonly isSpaceFavourited: boolean | null | undefined;
  } | null | undefined;
};
export type SpaceStarUnfavoriteSpaceMutation = {
  response: SpaceStarUnfavoriteSpaceMutation$data;
  variables: SpaceStarUnfavoriteSpaceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "FavouriteSpacePayload",
    "kind": "LinkedField",
    "name": "unfavouriteSpace",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "isSpaceFavourited"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SpaceStarUnfavoriteSpaceMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SpaceStarUnfavoriteSpaceMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9713a87882c5e6383e438ee687952963",
    "id": "24fcf7d9198609064e8a85eb41bcf50e2a570e7e7bb679c9d58b3ffec028c495",
    "metadata": {},
    "name": "SpaceStarUnfavoriteSpaceMutation",
    "operationKind": "mutation",
    "text": "mutation SpaceStarUnfavoriteSpaceMutation($spaceKey:String!){unfavouriteSpace(spaceKey:$spaceKey){isSpaceFavourited}}"
  }
};
})();

(node as any).hash = "947f8794b11432ca2dea89537ba4c2d6";

export default node;
